// src/pages/FilesManager/components/FileGrid.jsx
import React from 'react';
import FileCard from '../../../../components/FileCard/FileCard';



const FileGrid = ({files}) => {

  return (
    <div className="grid grid-cols-4 gap-4 mt-4">
      {files.map((file, idx) => (
        <FileCard key={idx} file={file} />
      ))}
    
    </div>
  );
};

export default FileGrid;
